import { useNavigate, useParams } from "react-router-dom";
import EventInfo from "../../../../components/sections/front/user-events-collections/EventInfo";
import Preview from "../../../../components/sections/front/user-events-collections/Preview";
import { useSelector } from "react-redux";
import { eventDetails } from "../../../../services/eventService";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";

const Publish = () => {
  const navigate = useNavigate();
  const { eventId } = useParams();
  const { lang } = useSelector((state) => state?.langProvider);
  const queryClient = useQueryClient();

  const {
    data: eventDetailsData,
    isLoading,
    isFetching,
  } = useQuery({
    queryKey: ["event-details", eventId],
    queryFn: async () => {
      const res = await eventDetails({ id: eventId, type: "front" });
      return res;
    },
    enabled: !!eventId,
  });

  useEffect(() => {
    return () => {
      queryClient?.removeQueries({ queryKey: ["event-details", eventId] });
    };
  }, []);

  if (!eventDetailsData?.data?._id && !isLoading && !isFetching) {
    navigate(`/${lang}/events`);
    return;
  }

  return (
    <div className="w-full relative flex flex-col lg:flex-row items-start gap-4 xl:gap-6">
      <div className="flex-shrink-0 w-full lg:w-72 xl:w-96 lg:top-24 lg:sticky">
        <EventInfo details={eventDetailsData} />
      </div>
      <div className="relative flex-shrink flex-grow">
        <Preview event={eventDetailsData?.data || {}} />
      </div>
    </div>
  );
};

export default Publish;
